export default function (totalCharge) {
  fbq("track", "Purchase", {
    content_name: "purchase",
    value: totalCharge,
    currency: "USD",
  });
}
